import _ from 'underscore';

import Backbone from 'backbone';
import ItemModel from './model';

export default Backbone.Collection.extend({

	model: ItemModel,

	sortDirection: null,
	sortProperty: null,

	url: function() {
		return document.URL;
	},

	// sortMethod used as comparator
	sortMethod: function(modelA, modelB) {
		var value = modelA.get(this.sortProperty),
			property = this.sortProperty,
			direction = this.sortDirection;

		if (_.isString(value)) {
			value = this.sortString(modelA, modelB, property);
		} else {
			value = this.sortNumber(modelA, modelB, property);
		}

		// Reverse sorting
		if (direction === 'desc') {
			value = value * -1;
		}

		return value;
	},

	// Cast string to lowercase to prevent backbone's native: numbers > lowercase > UPPERCASE > Defaultcase sort order.
	sortString: function(modelA, modelB, property) {
		var value = 0; // equal
		if (modelA.get(property).toLowerCase() > modelB.get(property).toLowerCase()) {
			value = 1; // after
		}

		if (modelB.get(property).toLowerCase() > modelA.get(property).toLowerCase()) {
			value = -1; // before
		}

		return value;
	},

	sortNumber: function(modelA, modelB, property) {
		return modelA.get(property) - modelB.get(property);
	},

	// Private
	// Trigger 'remove' event on the previous models, so that connected views can be removed
	onReset: function(collection, options) {
		_.each(options.previousModels, function(model) {
			model.trigger('remove');
		});
	},

	// Set sort propery and direction
	// Then call the sort method
	sortBy: function(property, direction) {
		this.sortProperty = property;
		this.sortDirection = direction;

		if (!this.comparator) {
			this.comparator = this.sortMethod;
		}

		this.sort();
	}
});
